<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            {{ !cd_campanha ? 'Adicionar nova campanha' : 'Editar campanha' }}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
          <div class="row">
            <div class="form-group col-12 col-md-3">
              <label for="nome">Cliente</label>
              <multiselect
                value="campanha.client_id"
                :close-on-select="true"
                track-by="company"
                label="company"
                v-model="campanha.client_id"
                :options="clients"
              ></multiselect>
            </div>

            <div class="form-group col-12 col-md-3">
              <label for="nome">Agência</label>
              <multiselect
                value="campanha.agency_id"
                :close-on-select="true"
                track-by="company"
                label="company"
                v-model="campanha.agency_id"
                :options="agencies"
              ></multiselect>
            </div>

            <div class="form-group col-12 col-md-2">
              <label for="type">Tipo Campanha</label>
              <select id="type" v-model="campanha.type" style="width: auto" class="form-control">
                <option v-for="(item, index) in tiposCampanha" v-bind:value="item" :key="index">{{ item }}</option>
              </select>
              <span v-show="errors.type != null" class="help-inline">{{ errors.type }}</span>
            </div>

            <div class="form-group col-12 col-md-3">
              <label for="seller">Vendedor</label>
              <select v-model="campanha.seller" id="seller" style="width: 100%" class="form-control">
                <option value="Adrien Duarte">Adrien Duarte</option>
                <option value="Agenciadores">Agenciadores</option>
                <option value="Bruno Genistretti">Bruno Genistretti</option>
                <option value="Flávia Pinho">Flávia Pinho</option>
                <option value="Gabriel Ribeiro">Gabriel Ribeiro</option>
                <option value="Isabel Cristina">Isabel Cristina</option>
                <option value="Media Plus">Media Plus</option>
                <option value="Outros">Outros</option>
                <option value="Outras Repres">Outras Repres</option>
                <option value="Programática">Programática</option>
                <option value="Repr Gov">Repr Gov</option>
                <option value="Rodrigo Rangel">Rodrigo Rangel</option>
                <option value="Simone Orlandi">Simone Orlandi</option>
                <option value="Tiago Pasqualetti">Tiago Pasqualetti</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-12 col-md-2">
              <label for="cod_op">Código</label>
              <input :disabled="cd_campanha" v-model="campanha.cod_op" id="cod_op" type="text" class="form-control">
            </div>

            <div class="form-group col-12 col-md-2">
              <label for="pi_number">Número PI </label>
              <input v-model="campanha.pi_number" maxlength="50" id="pi_number" type="text" class="form-control">
            </div>

            <div class="col-12 col-md-3">
              <label for="data">Período de veiculação geral  </label>
              <date-range-picker
                id="data"
                ref="picker"
                v-model="dateRange"
                :locale-data="localeData"
              ></date-range-picker>
            </div>

            <div class="form-group col-12 col-md-3">
              <label for="is_agency">Tipo do cliente</label>
              <br/>
              <toggle-button
                id="is_agency"
                v-model="campanha.is_agency"
                :labels="{ checked: 'Agência', unchecked: 'Cliente' }"
                :color="{ checked: '#f0ad4e', unchecked: '#00a65a', disabled: '#CCCCCC'}"
                :width="65"
                :sync="true"
              />
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button
              :disabled="!campanha.client_id || !campanha.pi_number || !campanha.seller  || !campanha.cod_op || !campanha.type"
              type="button"
              id="gravarButton"
              class="btn btn-success"
              @click="gravar()"
            >Gravar</button>
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="col" v-show="cd_campanha">
      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Produtos</h3>
          <button class="btn btn-sm btn-primary btn-novo" @click="novoProduto()" style="width: 33px; float: right">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>

        <div class="box-body">
          <div class="row">
            <div class="form-group col-2 col-xs-2"><b>Descrição</b></div>
            <div class="form-group col-2 col-xs-2 center"><b>Tipo Produto</b></div>
            <div class="form-group col-2 col-xs-2 center"><b>Pi Valor</b></div>
            <div class="form-group col-2 col-xs-1 center"><b>Inserções</b></div>
            <div class="form-group col-2 col-xs-1 center"><b>Carros</b></div>
            <div class="form-group col-2 col-xs-3 center"><b>Data</b></div>
            <div class="form-group col-1 col-xs-1"></div>
          </div>
          <div class="row" v-for="item in produtos" v-bind:key="item.cd_campanha_produto">
            <div class="form-group col-2 col-xs-2">{{ item.descricao }}</div>
            <div class="form-group col-2 col-xs-2 center">{{ item.product_type }}</div>
            <div class="form-group col-2 col-xs-2 center">{{ item.pi_value ? formatReal(item.pi_value) : '-' }}</div>
            <div class="form-group col-2 col-xs-1 center">{{ item.insertions ? formatarNumero(item.insertions) : '-' }}</div>
            <div class="form-group col-2 col-xs-1 center">{{ item.total_cars ? formatarNumero(item.total_cars) : '-' }}</div>
            <div class="form-group col-2 col-xs-3 center">{{ formatarData(item.start_date) + ' - ' + formatarData(item.end_date) }}</div>
            <div class="form-group col-1 col-xs-1 center_div">
              <div class="btn-group">
                <a @click="editarProduto(item.cd_campanha_produto)" class="btn btn-xs btn-warning legitRipple" data-tooltip="Editar" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-pencil"></span></a>
                <a @click="showExcluirProduto(cd_campanha, item.cd_campanha_produto, item.descricao)" class="btn btn-xs btn-danger legitRipple" data-tooltip="Remover" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-trash"></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Arquivos</h3>
          <button class="btn btn-sm btn-primary btn-novo" @click="novoArquivo()" style="width: 33px; float: right">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>

        <div class="box-body">
          <div class="row">
            <div class="form-group col-3 col-xs-3"><b>Arquivo</b></div>
            <div class="form-group col-3 col-xs-3 center"><b>Produto</b></div>
            <div class="form-group col-3 col-xs-2 center"><b>Praça</b></div>
            <div class="form-group col-2 col-xs-3 center"><b>Data</b></div>
            <div class="form-group col-1 col-xs-1"></div>
          </div>
          <div class="row" v-for="item in arquivos" v-bind:key="item.cd_campanha_arquivo">
            <div class="form-group col-3 col-xs-3">{{ item.midia }}</div>
            <div class="form-group col-3 col-xs-3 center">{{ item.produto_desc }}</div>
            <div class="form-group col-3 col-xs-2 center">{{ item.city }}</div>
            <div class="form-group col-2 col-xs-3 center">{{ formatarData(item.start_date) + ' - ' + formatarData(item.end_date) }}</div>
            <div class="form-group col-1 col-xs-1 center_div">
              <div class="btn-group">
                <a @click="editarArquivo(item.cd_campanha_arquivo)" class="btn btn-xs btn-warning legitRipple" data-tooltip="Editar" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-pencil"></span></a>
                <a @click="showExcluirArquivo(cd_campanha, item.cd_campanha_arquivo, item.midia)" class="btn btn-xs btn-danger legitRipple" data-tooltip="Remover" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-trash"></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal name="modal-produto" :adaptive="false" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-produto')">
            <span aria-hidden="true">×</span>
          </button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body">
          <div v-show="errorMessageModal != ''" class="alert alert-danger">
            {{ errorMessageModal }}
          </div>

          <div v-show="showModalProduto">
            <div class="row">
              <div class="form-group col-12 col-md-6">
                <label for="descricao">Descrição <sup class="text-danger">* </sup></label>
                <input id="descricao" v-model="produto.descricao" type="text" class="form-control">
                <span v-show="errors.descricao != null" class="help-inline">{{ errors.descricao }}</span>
              </div>

              <div class="form-group col-12 col-md-6">
                <label for="product_type">Tipo Produto <sup class="text-danger">* </sup></label>
                <select id="product_type" v-model="produto.product_type" style="width: auto" class="form-control">
                  <option v-for="(item, index) in tiposProduto" v-bind:value="item" :key="index">{{ item }}</option>
                </select>
                <span v-show="errors.product_type != null" class="help-inline">{{ errors.product_type }}</span>
              </div>

              <div class="form-group col-12 col-md-6">
                <label for="value-pi">Valor Bruto PI <sup class="text-danger">* </sup></label>
                <input v-model="produto.pi_value" v-money="money" id="value-pi" type="text" class="form-control">
                <span v-show="errors.pi_value != null" class="help-inline">{{ errors.pi_value }}</span>
              </div>

              <div class="form-group col-12 col-md-6">
                <label for="insertions">Inserções contratadas</label>
                <input v-model="insertions" id="insertions" maxlength="11" class="form-control">
              </div>
              
              <div class="col-12 col-md-6">
                <label for="data">Data <sup class="text-danger">* </sup></label>
                <date-range-picker
                  class="daterangepicker-modal"
                  id="data"
                  ref="picker"
                  v-model="produto.dateRange"
                  :locale-data="produto.localeData"
                ></date-range-picker>
              </div>

              <div class="form-group col-12 col-md-6">
                <label for="total_cars">Carros contratados</label>
                <input v-model="total_cars" id="total_cars" maxlength="11" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" @click="$modal.hide('modal-produto')">
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" @click="modalProdutoConfirma()">
            Confirmar
          </button>
        </div>
      </div>
    </modal>

    <modal name="modal-arquivo" :adaptive="false" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-arquivo')">
            <span aria-hidden="true">×</span>
          </button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body">
          <div v-show="errorMessageModal != ''" class="alert alert-danger">
            {{ errorMessageModal }}
          </div>

          <div v-show="showModalArquivo">
            <div class="row">
              <div class="form-group col-12 col-md-6">
                <label for="cd_campanha_produto">Produto <sup class="text-danger">* </sup></label>
                <select id="cd_campanha_produto" v-model="arquivo.cd_campanha_produto" style="width: auto" class="form-control">
                  <option v-for="(item, index) in campanhaProdutos" v-bind:value="item.id" :key="index">{{ item.descricao }}</option>
                </select>
                <span v-show="errors.cd_campanha_produto != null" class="help-inline">{{ errors.cd_campanha_produto }}</span>
              </div>

              <div class="form-group col-12 col-md-6">
                <label for="id_city">Praça <sup class="text-danger">* </sup></label>
                <select id="id_city" v-model="arquivo.id_city" style="width: auto" class="form-control">
                  <option v-for="(item, index) in cidades" v-bind:value="item.id_city" :key="index">{{ item.city }}</option>
                </select>
                <span v-show="errors.id_city != null" class="help-inline">{{ errors.id_city }}</span>
              </div>

              <div class="col-12 col-md-6">
                <label for="data">Data <sup class="text-danger">* </sup></label>
                <date-range-picker
                  class="daterangepicker-modal"
                  id="data"
                  ref="picker"
                  v-model="arquivo.dateRange"
                  :locale-data="arquivo.localeData"
                ></date-range-picker>
              </div>

              <div class="form-group col-12 col-md-6" v-show="Array.isArray(arquivo.midia)">
                <label for="name">Arquivo <sup class="text-danger">* </sup></label>
                <div style="height: 40px; display: inline-block;"
                  v-for="(item, index) in arquivo.midia"
                  :key="index"
                >
                  <label for="name" style="padding: 5px 4px 0 0;">{{ (index + 1) }})</label>

                  <button type="button" class="btn btn-xs btn-danger"
                    style="float: right; height: 24px; margin: 5px 0 0 6px;"
                    @click="removeCampoArquivo(index)">
                    <i class="fas fa-minus"></i>
                  </button>

                  <input v-model="arquivo.midia[index]" id="name" type="text" class="form-control" style="float: right; width: 220px;" />
                  <span v-show="errors[`midia${index}`] != null" class="help-inline">{{ errors[`midia${index}`] }}</span>
                </div>

                <span v-show="errors.midia_main != null" class="help-inline">
                  <br/>{{ errors.midia_main }}
                </span>

                <button type="button" class="btn btn-xs btn-success"
                  style="width: 50px; float: right;"
                  @click="addCampoArquivo()">
                  <i class="fas fa-plus"></i>
                </button>
              </div>

              <div class="form-group col-12 col-md-6" v-show="!Array.isArray(arquivo.midia)">
                <label for="name">Arquivo <sup class="text-danger">* </sup></label>
                <input v-model="arquivo.midia" id="name" type="text" class="form-control">
                <span v-show="errors.midia_main != null" class="help-inline">{{ errors.midia_main }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" @click="$modal.hide('modal-arquivo')">
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" @click="modalArquivoConfirma()">
            Confirmar
          </button>
        </div>
      </div>
    </modal>

    <modal name="modal-excluir-produto" :adaptive="false" width="600" height="auto" class="modal-danger">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-excluir-produto')"><span aria-hidden="true">×</span></button>
          <h3 class="modal-title">Excluir</h3>
        </div>
        <div class="modal-body">
          <div v-html="bodyModal"></div>
          <div v-show="errorMessageModal != ''" class="alert alert-warning" style="margin: 10px">{{ errorMessageModal }}</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" @click="$modal.hide('modal-excluir-produto')">Cancelar</button>
          <button type="button" class="btn btn-primary btn-outline" @click="excluirProduto()">Confirmar</button>
        </div>
      </div>
    </modal>

    <modal name="modal-excluir-arquivo" :adaptive="false" width="600" height="auto" class="modal-danger">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-excluir-arquivo')"><span aria-hidden="true">×</span></button>
          <h3 class="modal-title">Excluir</h3>
        </div>
        <div class="modal-body">
          <div v-html="bodyModal"></div>
          <div v-show="errorMessageModal != ''" class="alert alert-warning" style="margin: 10px">{{ errorMessageModal }}</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" @click="$modal.hide('modal-excluir-arquivo')">Cancelar</button>
          <button type="button" class="btn btn-primary btn-outline" @click="excluirArquivo()">Confirmar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import ToggleButton from 'vue-js-toggle-button'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import DateRangePicker from 'vue2-daterange-picker'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import Actions from '../../actions/CampanhasActions'
import ParamentroActions from '../../actions/ParametrosSistemaActions'

Vue.use(ToggleButton)

export default {
  name: 'novo',
  props: ['id'],
  components: {
    DateRangePicker,
    Multiselect
  },
  data () {
    let startDate = new Date()
    let endDate = new Date()
    endDate.setDate(startDate.getDate() + 7)

    return {
      titleModal: '',
      bodyModal: '',
      errorMessageModal: '',
      showModalLoader: 0,
      errors: {},
      showModalProduto: false,
      showModalArquivo: false,
      row_excluir_produto: {},
      row_excluir_arquivo: {},
      cd_campanha: '',
      clients: [],
      agencies: [],
      tiposCampanha: [],
      tiposProduto: [],
      name: '',
      os_number: '',
      campanha: {
        start_date: startDate,
        end_date: endDate,
        cod_op: '',
        pi_number: '',
        seller: '',
        client_id: '',
        agency_id: '',
        is_agency: false,
        type: ''
      },
      campanhaProdutos: [],
      produtos: [],
      arquivos: [],
      cidades: [
        {
          id_city: 3106200,
          city: 'Belo Horizonte'
        },
        {
          id_city: 3550308,
          city: 'São Paulo'
        }
      ],
      produto: {
        cd_campanha_produto: '',
        cd_campanha: this.cd_campanha,
        descricao: '',
        product_type: '',
        pi_value: '',
        insertions: null,
        total_cars: null,
        start_date: startDate,
        end_date: endDate,
        dateRange: { startDate, endDate },
        localeData: {
          format: 'dd/mm/yyyy',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar'
        }
      },
      arquivo: {
        cd_campanha_arquivo: '',
        cd_campanha_produto: '',
        midia: [''],
        id_city: '',
        start_date: startDate,
        end_date: endDate,
        dateRange: { startDate, endDate },
        localeData: {
          format: 'dd/mm/yyyy',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar'
        }
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2
        // masked: false
      },
      localeData: {
        format: 'dd/mm/yyyy',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar'
      },
      dateRange: { startDate, endDate },
      insertions: null,
      total_cars: null
    }
  },
  created () {
    this.cd_campanha = this.id

    if (this.cd_campanha) {
      this.$parent.$parent.$data.description = 'Editar'
    } else {
      this.$parent.$parent.$data.description = 'Novo'
    }
  },
  watch: {
    insertions: function (newValue) {
      this.insertions = this.formatarNumero(newValue)
    },

    total_cars: function (newValue) {
      this.total_cars = this.formatarNumero(newValue)
    }
  },
  mounted () {
    this.$parent.$parent.$data.showModalLoader = true

    this.listClients()
      .then(() => {
        this.$parent.$parent.$data.showModalLoader = false
        if (this.cd_campanha) {
          this.getCampanha()
        }
      })

    ParamentroActions
      .getParametroByLista([
        'TIPO_CAMPANHA',
        'TIPO_CAMPANHA_PRODUTO'
      ])
      .then((params) => {
        let TIPO_CAMPANHA = params
          .find((i) => i.cd_parametro === 'TIPO_CAMPANHA')
        let TIPO_CAMPANHA_PRODUTO = params
          .find((i) => i.cd_parametro === 'TIPO_CAMPANHA_PRODUTO')

        this.tiposCampanha = TIPO_CAMPANHA ? TIPO_CAMPANHA.valor.split(',') : []
        this.tiposProduto = TIPO_CAMPANHA_PRODUTO ? TIPO_CAMPANHA_PRODUTO.valor.split(',') : []
      })
  },
  methods: {
    setSeller (seller) {
      if (seller === 'Flavia Pinho') {
        this.campanha.seller = 'Flávia Pinho'
      } else {
        this.campanha.seller = seller
      }
    },
    getCampanha () {
      this.$parent.$parent.$data.showModalLoader = true

      Actions
        .getCampanha(this.cd_campanha)
        .then(res => {
          if (res) {
            this.campanha = res
            this.produtos = res.produtos

            if (this.produtos && this.produtos.length > 0) {
              this.arquivos = []

              res.produtos.forEach(i => {
                this.arquivos = this.arquivos.concat(i.arquivos)
              })

              this.arquivos = this.arquivos.map(i => {
                const city = this.cidades.find(c => c.id_city === i.id_city)
                return Object.assign(i, {
                  city: city ? city.city : null,
                  produto_desc: this.produtos.find(c => c.cd_campanha_produto === i.cd_campanha_produto).descricao
                })
              })

              this.campanhaProdutos = this.produtos.map(i => ({
                id: i.cd_campanha_produto,
                descricao: i.descricao
              }))
            }

            this.campanha.client_id = this.clients.find((i) => i.id === this.campanha.client_id)
            this.campanha.agency_id = this.agencies.find((i) => i.id === this.campanha.agency_id)
            this.dateRange.startDate = moment(this.campanha.start_date)
            this.dateRange.endDate = moment(this.campanha.end_date)

            this.setSeller(res.seller)
          }

          this.$parent.$parent.$data.showModalLoader = false
        })
        .catch(error => {
          console.log(error)
          this.$parent.$parent.$data.showModalLoader = false
        })
    },
    listClients () {
      return Actions
        .listClients()
        .then(res => {
          this.clients = res.filter((i) => i.type === 1)
          this.agencies = res.filter((i) => i.type === 2)
        })
    },
    voltar () {
      this.$router.push('/campanhas/listar')
    },
    getValueParse (formatValue) {
      let value = formatValue.substr(3)
      value = value.replace('.', '')
      value = parseFloat(value.replace(',', '.'))

      return String(value)
    },
    gravar () {
      this.$parent.$parent.$data.showModalLoader = true

      this.campanha.client_id = this.campanha.client_id.id
      this.campanha.agency_id = this.campanha.agency_id ? this.campanha.agency_id.id : null
      this.campanha.start_date = moment(this.dateRange.startDate).format('YYYY-MM-DD')
      this.campanha.end_date = moment(this.dateRange.endDate).format('YYYY-MM-DD')

      if (this.cd_campanha) {
        delete this.campanha.cd_campanha

        Actions
          .updateCampanha({
            campanha: this.campanha,
            cd_campanha: this.cd_campanha
          })
          .then(() => {
            this.$parent.$parent.$data.showModalLoader = false
            this.$notification.success('Registro gravado com sucesso', { timer: 10 })
          })
          .catch((error) => {
            this.$parent.$parent.$data.showModalLoader = false
            console.log(error)
          })
      } else {
        Actions
          .cadastrarCampanha(this.campanha)
          .then((response) => {
            this.$parent.$parent.$data.showModalLoader = false
            this.$notification.success('Registro gravado com sucesso', { timer: 10 })
            this.$router.push(`/campanhas/${response.data.cd_campanha}/e`)
            this.cd_campanha = response.data.cd_campanha
            this.getCampanha()
          })
          .catch((error) => {
            console.log(error.response.data.message)
            this.$notification.error(error.response.data.message, { timer: 10 })
            this.errorMessage = error.response.data.message
            this.$parent.$parent.$data.showModalLoader = false
          })
      }
    },
    novoProduto () {
      this.titleModal = 'Novo Produto'
      this.showModalProduto = true
      this.errorMessageModal = ''
      this.errors = {}
      this.$modal.show('modal-produto')
      this.cd_campanha_produto = null

      this.insertions = null
      this.total_cars = null
      this.produto = {
        cd_campanha_produto: '',
        cd_campanha: this.cd_campanha,
        descricao: '',
        product_type: '',
        pi_value: '',
        insertions: null,
        total_cars: null,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        dateRange: JSON.parse(JSON.stringify(this.dateRange)),
        localeData: {
          format: 'dd/mm/yyyy',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar'
        }
      }
    },
    editarProduto (cdCampanhaProduto) {
      this.titleModal = 'Editar Produto'
      this.errorMessageModal = ''
      this.errors = {}
      this.showModalProduto = false
      this.$modal.show('modal-produto')
      this.cd_campanha_produto = cdCampanhaProduto

      Actions
        .getProduto(this.cd_campanha, cdCampanhaProduto)
        .then(res => {
          if (res) {
            this.produto = res
            this.produto.dateRange = {
              startDate: moment(this.produto.start_date),
              endDate: moment(this.produto.end_date)
            }
            this.produto.localeData = {
              format: 'dd/mm/yyyy',
              applyLabel: 'Aplicar',
              cancelLabel: 'Cancelar'
            }
            this.insertions = this.produto.insertions
            this.total_cars = this.produto.total_cars
            this.showModalProduto = true
          } else {
            this.errorMessageModal = 'Registro nao encontrado.'
          }
        })
    },
    modalProdutoConfirma () {
      this.errors = {}
      let hasError = false
      let insertions = String(this.insertions).replace(/[^\d]/g, '')
      let totalCars = String(this.total_cars).replace(/[^\d]/g, '')

      let produto = {
        cd_campanha_produto: this.cd_campanha_produto,
        descricao: this.produto.descricao,
        pi_value: this.produto.pi_value.replace(/[^0-9,]*/g, '').replace(',', '.'),
        cd_campanha: this.cd_campanha,
        product_type: this.produto.product_type,
        insertions: insertions === '' ? null : insertions,
        total_cars: totalCars === '' ? null : totalCars,
        start_date: moment(this.produto.dateRange.startDate).format('YYYY-MM-DD'),
        end_date: moment(this.produto.dateRange.endDate).format('YYYY-MM-DD')
      }

      if (!this.produto.descricao) {
        this.errors.descricao = 'Este campo deve ser preenchido.'
        hasError = true
      }

      if (!this.produto.product_type) {
        this.errors.product_type = 'Este campo deve ser preenchido.'
        hasError = true
      }

      if (!produto.pi_value) {
        this.errors.pi_value = 'Este campo deve ser preenchido.'
        hasError = true
      }

      if (!hasError) {
        this.$parent.$parent.$data.showModalLoader = true
        if (this.cd_campanha_produto) {
          Actions
            .updateProduto(
              this.cd_campanha,
              produto
            )
            .then(res => {
              this.$parent.$parent.$data.showModalLoader = false
              this.$modal.hide('modal-produto')
              this.getCampanha()
            })
            .catch(error => {
              this.errorMessageModal = error.response.data.error
              this.$parent.$parent.$data.showModalLoader = false
            })
        } else {
          Actions
            .inserirProduto(
              this.cd_campanha,
              produto
            )
            .then(res => {
              this.$parent.$parent.$data.showModalLoader = false
              this.$modal.hide('modal-produto')
              this.getCampanha()
            })
            .catch(error => {
              this.errorMessageModal = error.response.data.error
              this.$parent.$parent.$data.showModalLoader = false
            })
        }
      }
    },
    showExcluirProduto (cdCampanha, cdCampanhaProduto, descricao) {
      this.bodyModal = `Deseja realmente EXCLUIR o produto '${descricao}'?`
      this.errorMessageModal = ''
      this.row_excluir_produto = {
        cd_campanha: cdCampanha,
        cd_campanha_produto: cdCampanhaProduto
      }

      this.$modal.show('modal-excluir-produto')
    },
    excluirProduto () {
      Actions
        .deleteProduto(this.row_excluir_produto.cd_campanha, this.row_excluir_produto.cd_campanha_produto)
        .then(res => {
          this.$modal.hide('modal-excluir-produto')
          this.$parent.$parent.$data.showModalLoader = false
          this.getCampanha()
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessageModal = 'Ocorreu um erro ao excluir o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
    },
    novoArquivo () {
      this.titleModal = 'Novo Arquivo'
      this.showModalArquivo = true
      this.errorMessageModal = ''
      this.errors = {}
      this.$modal.show('modal-arquivo')
      this.cd_campanha_arquivo = null

      this.arquivo = {
        cd_campanha_arquivo: '',
        cd_campanha_produto: '',
        midia: [''],
        id_city: '',
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        dateRange: JSON.parse(JSON.stringify(this.dateRange)),
        localeData: {
          format: 'dd/mm/yyyy',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar'
        }
      }
    },
    editarArquivo (cdCampanhaArquivo) {
      this.titleModal = 'Editar Arquivo'
      this.errorMessageModal = ''
      this.errors = {}
      this.showModalArquivo = false
      this.$modal.show('modal-arquivo')
      this.cd_campanha_arquivo = cdCampanhaArquivo

      Actions
        .getArquivo(this.cd_campanha, cdCampanhaArquivo)
        .then(res => {
          if (res) {
            this.arquivo = res
            this.arquivo.dateRange = {
              startDate: moment(this.arquivo.start_date),
              endDate: moment(this.arquivo.end_date)
            }
            this.arquivo.localeData = {
              format: 'dd/mm/yyyy',
              applyLabel: 'Aplicar',
              cancelLabel: 'Cancelar'
            }
            this.showModalArquivo = true
          } else {
            this.errorMessageModal = 'Registro nao encontrado.'
          }
        })
    },
    modalArquivoConfirma () {
      this.errors = {}
      let hasError = false

      if (!this.arquivo.cd_campanha_produto) {
        this.errors.cd_campanha_produto = 'Este campo deve ser preenchido.'
        hasError = true
      }

      if (!this.arquivo.id_city) {
        this.errors.id_city = 'Este campo deve ser preenchido.'
        hasError = true
      }

      if (!Array.isArray(this.arquivo.midia)) {
        if (!this.arquivo.midia) {
          this.errors.midia_main = 'Este campo deve ser preenchido.'
          hasError = true
        }
      } else {
        if (!this.arquivo.midia || !this.arquivo.midia.length) {
          this.errors.midia_main = 'Este campo deve ser preenchido.'
          hasError = true
        } else {
          this.arquivo.midia.forEach((i, k) => {
            if (!i) {
              this.errors[`midia${k}`] = 'Este campo deve ser preenchido.'
              hasError = true
            }
          })
        }
      }

      if (!hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        if (this.cd_campanha_arquivo) {
          const arquivo = {
            cd_campanha_arquivo: this.cd_campanha_arquivo,
            cd_campanha_produto: this.arquivo.cd_campanha_produto,
            midia: this.arquivo.midia,
            id_city: this.arquivo.id_city,
            start_date: moment(this.arquivo.dateRange.startDate).format('YYYY-MM-DD'),
            end_date: moment(this.arquivo.dateRange.endDate).format('YYYY-MM-DD')
          }

          Actions
            .updateArquivo(
              this.cd_campanha,
              arquivo
            )
            .then(() => {
              this.$parent.$parent.$data.showModalLoader = false
              this.$modal.hide('modal-arquivo')
              this.getCampanha()
            })
            .catch(error => {
              this.errorMessageModal = error.response.data.error
              this.$parent.$parent.$data.showModalLoader = false
            })
        } else {
          this.arquivo.midia.forEach((i) => {
            const arquivo = {
              cd_campanha_arquivo: this.cd_campanha_arquivo,
              cd_campanha_produto: this.arquivo.cd_campanha_produto,
              midia: i,
              id_city: this.arquivo.id_city,
              start_date: moment(this.arquivo.dateRange.startDate).format('YYYY-MM-DD'),
              end_date: moment(this.arquivo.dateRange.endDate).format('YYYY-MM-DD')
            }

            Actions
              .inserirArquivo(
                this.cd_campanha,
                arquivo
              )
              .then(() => {
                this.$parent.$parent.$data.showModalLoader = false
                this.$modal.hide('modal-arquivo')
                this.getCampanha()
              })
              .catch(error => {
                this.errorMessageModal = error.response.data.error
                this.$parent.$parent.$data.showModalLoader = false
              })
          })
        }
      }
    },
    addCampoArquivo () {
      this.arquivo.midia.push('')
      this.errors = {}
    },
    removeCampoArquivo (key) {
      delete this.arquivo.midia.splice(key, 1)
      this.errors = {}
    },
    showExcluirArquivo (cdCampanha, cdCampanhaArquivo, midia) {
      this.bodyModal = `Deseja realmente EXCLUIR o arquivo '${midia}'?`
      this.errorMessageModal = ''
      this.row_excluir_arquivo = {
        cd_campanha: cdCampanha,
        cd_campanha_arquivo: cdCampanhaArquivo
      }

      this.$modal.show('modal-excluir-arquivo')
    },
    excluirArquivo () {
      Actions
        .deleteArquivo(this.row_excluir_arquivo.cd_campanha, this.row_excluir_arquivo.cd_campanha_arquivo)
        .then(() => {
          this.$modal.hide('modal-excluir-arquivo')
          this.getCampanha()
          this.$parent.$parent.$data.showModalLoader = false
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessageModal = 'Ocorreu um erro ao excluir o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
    },
    formatarData (val, exibeHora = false) {
      let date = moment.utc(val)
      if (date.isValid()) {
        return exibeHora ? date.format('DD/MM/YYYY HH:mm') : date.format('DD/MM/YYYY')
      }
      return ''
    },
    formatarNumero (val) {
      if (val) {
        return String(val).replace(/\D/g, '')
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      return val
    },
    formatReal (val) {
      if (val) {
        let n = val.split('.')
        let r = n[0].replace(/\D/g, '')
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')

        return n.length > 0 ? `R$ ${r},${n[1]}` : `R$ ${r},00`
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags {
  height: 34px;
  min-height: unset;
}
.vue-daterange-picker {
  display: contents !important;
}
.daterangepicker-modal > .daterangepicker {
  position: fixed !important;
}
.v--modal-box {
  top: 70px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/campanhas/Novo.vue